import { Button, Dialog, Input, Textarea } from '@cloudflare/kumo'
import { PaperPlaneTilt } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'

/** 사용자에게 보낼 인앱 알림 + 푸시 작성 창. 보내면 앱의 알림 탭에 남고 푸시가 간다 */
export function MessageDialog({
  open,
  heading,
  description,
  defaultTitle = '',
  busy = false,
  onSend,
  onClose,
}: {
  open: boolean
  heading: string
  description: string
  defaultTitle?: string
  busy?: boolean
  onSend: (msg: { title: string; body: string }) => void
  onClose: () => void
}) {
  const [title, setTitle] = useState(defaultTitle)
  const [body, setBody] = useState('')
  useEffect(() => {
    if (open) {
      setTitle(defaultTitle)
      setBody('')
    }
  }, [open, defaultTitle])
  const valid = title.trim().length > 0 && body.trim().length > 0
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Dialog size="base" className="p-6">
        <Dialog.Title className="text-lg font-semibold">{heading}</Dialog.Title>
        <Dialog.Description className="text-kumo-subtle mt-1">{description}</Dialog.Description>
        <div className="mt-5 flex flex-col gap-4">
          <Input
            label="제목"
            maxLength={80}
            value={title}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
          />
          <Textarea
            label="내용"
            maxLength={500}
            value={body}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setBody(e.target.value)}
          />
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <Button variant="secondary" disabled={busy} onClick={onClose}>
            취소
          </Button>
          <Button
            variant="primary"
            icon={<PaperPlaneTilt />}
            loading={busy}
            disabled={!valid}
            onClick={() => onSend({ title: title.trim(), body: body.trim() })}
          >
            보내기
          </Button>
        </div>
      </Dialog>
    </Dialog.Root>
  )
}
